import * as Select from '@radix-ui/react-select'
import type { ReactNode } from 'react'
import { CheckIcon } from '@radix-ui/react-icons'
import { ChevronDown } from '../../../../cars/components/V3/icons'

export type AccessValueProps = 'YES' | 'NO' | 'OWN_CAR_ONLY'

export const AccessSelect = ({
  id = 'access',
  name = 'access',
  value,
  onValueChange,
}: {
  id?: string
  name?: string
  value: AccessValueProps
  onValueChange: (value: AccessValueProps) => void
}) => {
  return (
    <Select.Root value={value} onValueChange={(value) => onValueChange(value as AccessValueProps)}>
      <input type="hidden" name={name} value={value} />

      <Select.Trigger
        id={id}
        className="flex py-2 px-4 w-full mt-2 max-h-[39px] items-center overflow-hidden text-ellipsis justify-between rounded-md border border-borderGray shadow-soft bg-white"
        aria-label="Tilgang til hele selskapet"
      >
        <Select.Value placeholder="Velg..." />
        <Select.Icon>
          <ChevronDown rotated />
        </Select.Icon>
      </Select.Trigger>

      <Select.Portal>
        <Select.Content
          position="popper"
          sideOffset={8}
          side="bottom"
          className="z-50 text-secondaryText overflow-hidden rounded-md border border-borderGray bg-white shadow-soft min-w-[var(--radix-select-trigger-width)]"
        >
          <Select.Viewport className="p-1">
            <SelectItem value="YES">Ja</SelectItem>
            <SelectItem value="NO">Nei</SelectItem>
            <SelectItem value="OWN_CAR_ONLY">Kun egen bil</SelectItem>
          </Select.Viewport>
        </Select.Content>
      </Select.Portal>
    </Select.Root>
  )
}

const SelectItem = ({ value, children }: { value: string; children: ReactNode }) => {
  return (
    <Select.Item
      value={value}
      className="relative flex select-none items-center rounded-md px-8 py-2 outline-none cursor-pointer data-[highlighted]:font-semibold data-[highlighted]:bg-blueLight"
    >
      <Select.ItemText>{children}</Select.ItemText>
      <Select.ItemIndicator className="absolute left-2 inline-flex items-center">
        <CheckIcon />
      </Select.ItemIndicator>
    </Select.Item>
  )
}
